import { toast } from "react-toastify";
import axiosInstance from "../../../../axiosInstance";
import { HRMS_EMPLOYEE_API_URL } from "../../../Constants/baseConstant";
import { getDomain, getUserId } from "../../Base/helper/baseFunctions";
import NProgress from 'nprogress';

export const GetPerformanceLogHelper = async (params) => {
    NProgress.start();
    return await axiosInstance(`/pms/Performance/getPerformanceLog`, {
        method: "POST",
        baseURL: HRMS_EMPLOYEE_API_URL,
        data: {
            domain_name: getDomain(),
            user_id: params?.user_id === "null" ? null : getUserId(),
        }
    })
    .then((res) => {
        NProgress.done();
        return { message: "Performance logs retrieved successfully", hasError: false, data: res?.data }
    }).catch(err => {
        NProgress.done();
        return { message: "Unable to retrieve performance logs", hasError: true, data: err?.response?.data }
    });
};

// Add Performance Log
export const AddPerformanceLogHelper = async (params) => {
    toast.dismiss();
    toast.info("Saving...");
    return await axiosInstance(`/pms/Performance/addPerformanceLog`, {
        method: "POST",
        baseURL: HRMS_EMPLOYEE_API_URL,
        data: {
            domain_name: getDomain(),
            user_id: getUserId(),
            goal_sub_category_configuration_fk: +params?.goal_sub_category_configuration_pk?.goal_sub_category_configuration_pk,
            checkin_type: params?.checkin_type?.value,
            checkin_title: params?.checkin_title,
            checkin_start_date: params?.checkin_start_date,
            checkin_end_date: params?.checkin_end_date,
            checkin_progress: params?.checkin_progress,
            checkin_comments: params?.checkin_comments,
        }
    })
    .then((res) => {
        toast.dismiss();
        toast.success("Check-In added successfully");
        return { message: "Check-In added successfully", hasError: false, data: res?.data }
    }).catch(err => {
        toast.dismiss();
        toast.error(err?.response?.data?.error?.[0]?.message);
        return { message: "Unable to add performance log", hasError: true, data: err?.response?.data }
    });
};

// Update Performance Log
export const UpdatePerformanceLogHelper = async (params) => {
    toast.dismiss();
    toast.info("Updating...");
    return await axiosInstance(`/pms/Performance/updatePerformanceLog`, {
        method: "PUT",
        baseURL: HRMS_EMPLOYEE_API_URL,
        data: {
            domain_name: getDomain(),
            user_id: getUserId(),
            goal_sub_category_configuration_fk: +params?.goal_sub_category_configuration_pk?.goal_sub_category_configuration_pk,
            checkin_pk: +params?.checkin_pk,
            checkin_type: params?.checkin_type?.value,
            checkin_title: params?.checkin_title,
            checkin_start_date: params?.checkin_start_date,
            checkin_end_date: params?.checkin_end_date,
            checkin_progress: params?.checkin_progress,
            checkin_comments: params?.checkin_comments,
        }
    })
    .then((res) => {
        toast.dismiss();
        toast.success("Check-In updated successfully");
        return { message: "Check-In updated successfully", hasError: false, data: res?.data }
    }).catch(err => {
        toast.dismiss();
        toast.error(err?.response?.data?.error?.[0]?.message);
        return { message: "Unable to update performance log", hasError: true, data: err?.response?.data }
    });
};

// Delete Performance Log
export const DeletePerformanceLogHelper = async (params) => {
    toast.dismiss();
    toast.info("Deleting...");
    return await axiosInstance(`/pms/Performance/deletePerformanceLog`, {
        method: "DELETE",
        baseURL: HRMS_EMPLOYEE_API_URL,
        data: {
            domain_name: getDomain(),
            user_id: getUserId(),
            checkin_pk: +params?.checkin_pk
        }
    })
    .then((res) => {
        toast.dismiss();
        toast.success("Check-In deleted successfully");
        return { message: "Check-In deleted successfully", hasError: false, data: res?.data }
    }).catch(err => {
        toast.dismiss();
        toast.error(err?.response?.data?.error?.[0]?.message);
        return { message: "Unable to delete Check-In", hasError: true, data: err?.response?.data }
    });
};